module.exports = __webpack_public_path__ + "img/Transak.56a0ed46.png";